import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import LogoutButton from '../../components/Button/LogoutButton';

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<MuiAppBarProps & { open?: boolean }>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.standard,
  }),
}));

interface AppBarComponentProps {
  open: boolean;
  handleDrawerOpen: () => void;
  auth: boolean;
  anchorEl: null | HTMLElement;
  handleMenu: (event: React.MouseEvent<HTMLElement>) => void;
  handleClose: () => void;
  title: string; // Prop para el título
}

export default function AppBarComponent({
  open,
  handleDrawerOpen,
  auth,
  anchorEl,
  handleMenu,
  handleClose,
  title
}: AppBarComponentProps) {
  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          height: 28,
          backgroundColor: '#3366cc',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 2,
          fontSize: 12,
          fontWeight: 700,
          zIndex: (theme) => theme.zIndex.drawer + 2,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <img src="/images/logo2.webp" alt="Gov" style={{ height: 14, width: 'auto' }} />
          <span>GOV.CO</span>
        </Box>
        <span>Portal Interno EMCALI</span>
      </Box>
      <AppBar
        position="fixed"
        open={open}
        sx={{
          top: 28,
          backgroundColor: '#ffffff',
          color: '#1f2937',
          boxShadow: 'none',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <Toolbar sx={{ minHeight: 72 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              color="default"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 2,
              }}
            >
              <MenuIcon />
            </IconButton>
            <img
              src="/images/logo-emcali.webp"
              alt="Logo EMCALI"
              style={{ height: '44px', width: 'auto', display: 'block' }}
            />
          </Box>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, textAlign: 'center', fontWeight: 700, color: '#0f172a' }}
          >
            {title}
          </Typography>
          {auth && (
            <div>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleMenu}
                color="default"
                sx={{
                  border: '1px solid #e5e7eb',
                  borderRadius: 2,
                  backgroundColor: '#f8fafc',
                }}
              >
                <AccountCircle />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <LogoutButton handleClose={handleClose} />
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
      <Box
        sx={{
          position: 'fixed',
          left: 0,
          right: 0,
          bottom: 0,
          minHeight: 34,
          backgroundColor: '#518711',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
          fontSize: 12,
          fontWeight: 600,
          zIndex: (theme) => theme.zIndex.drawer + 1,
          textAlign: 'center',
        }}
      >
        EMPRESAS MUNICIPALES DE CALI - EMCALI EICE ESP
      </Box>
    </>
  );
}


